import { Platform } from 'react-native'

// 解析版本字符串，返回数字数组 [major, minor, patch]
function parseVersion(version: string): number[] {
  return version
    .split('.')
    .map(Number)
    .filter(n => !isNaN(n))
}

// 比较两个版本数组
function compareVersions(a: number[], b: number[]): number {
  const maxLength = Math.max(a.length, b.length)
  for (let i = 0; i < maxLength; i++) {
    const aPart = a[i] ?? 0
    const bPart = b[i] ?? 0
    if (aPart > bPart) return 1
    if (aPart < bPart) return -1
  }
  return 0
}

export const IOS_VERSION = Platform.OS === 'ios' ? parseVersion(Platform.Version.toString())[0] : 0

// 检查 iOS 版本是否低于指定版本
function isBelowIOSVersion(targetVersion: number[]): boolean {
  if (Platform.OS !== 'ios') return false
  const currentVersion = parseVersion(Platform.Version.toString())
  return compareVersions(currentVersion, targetVersion) < 0
}

export const isBelowiOS26 = isBelowIOSVersion([26])
export const isBelowiOS18 = isBelowIOSVersion([18])
